import type { AdditionalSelectors } from '@makemydeal/dr-activities-role-assumption';
import { getSalesCheckinBffEndPoint } from '@makemydeal/dr-sales-checkin-ui-utils';

export const additionalSelectors: AdditionalSelectors = {
    getValidateUserURL: () => {
        return getSalesCheckinBffEndPoint('role-assumption/validation');
    }
};
